<template>
  <div class="money-input-container mb-3">
    <label>
      <question-display :question="question" customClass="header-number-input"></question-display>
    </label>
    <input
      type="text"
      v-model="inputValue"
      :placeholder="question.placeholder || ''"
      class="form-control"
      @input="onInput"
    />
    <small v-if="showValidation && !isValidInput()" class="text-danger">{{ errorMsg }}</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService';
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
    QuestionDisplay
  },
  props: {
    question: Object,
    showValidation: Boolean
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id)?.toString() || '',
      errorMsg: ''
    };
  },
  methods: {
    onInput(event) {
      let raw = event.target.value.toUpperCase();

      // Remove invalid characters: only digits, commas, and trailing K
      raw = raw.replace(/[^0-9K,]/g, ''); // remove all invalid chars
      raw = raw.replace(/(K)(?=.)/g, ''); // remove K unless at end

      const hasK = raw.endsWith('K');

      // Strip commas to calculate numeric value
      let numericPart = raw.replace(/,/g, '');
      if (hasK) numericPart = numericPart.slice(0, -1); // remove trailing K

      let parsedValue = numericPart ? parseInt(numericPart, 10) : 0;
      if (hasK) parsedValue *= 1000;

      // Format number with commas for display
      let formatted = numericPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (hasK) formatted += 'K';

      // Update UI and storage
      this.inputValue = formatted;
      surveyService.setAnswer(this.question.id, parsedValue);
      this.$emit('input', parsedValue);
    },

    isValidInput() {
      const raw = this.inputValue.toUpperCase();
      const validFormat = /^(\d{1,3}(,\d{3})*|\d+)(K)?$/.test(raw);

      if (this.question.required && !this.inputValue) {
        this.errorMsg = 'This field is required.';
        return false;
      }

      if (!validFormat) {
        this.errorMsg = 'Please enter a valid amount (e.g. 80K or 80,000)';
        return false;
      }

      this.errorMsg = '';
      return true;
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id)?.toString() || '';
    }
  }
};
</script>
